var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassDialog",
    {
      staticClass: "activities-listing-mass-modify-owner",
      attrs: {
        visible: _vm.showModal,
        size: "small",
        closeOnClickOverlay: false,
        title: _vm.$t.__(
          "activities.listing.massActions.ActivitiesListingMassActions.modify_owner"
        ),
        primaryAction: {
          label: _vm.$t.__("common.actions.confirm"),
          disabled: _vm.isConfirmButtonDisabled,
          action: function() {
            return _vm.confirmMassModifyOwner()
          },
          loading: _vm.isSubmitting
        },
        secondaryActions: [
          {
            label: _vm.$t.__("common.actions.cancel"),
            disabled: _vm.isSubmitting,
            action: function() {
              return _vm.$emit("close")
            }
          }
        ]
      },
      on: {
        "update:visible": function($event) {
          _vm.showModal = $event
        },
        closed: function($event) {
          return _vm.$emit("close")
        }
      }
    },
    [
      [
        _c("span", { staticClass: "typographies-paragraph-medium-semibold" }, [
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t.__("common.labels.staff")) +
              "\n        "
          )
        ]),
        _vm._v(" "),
        _c(
          "CompassSelect",
          {
            attrs: {
              placeholder: _vm.$t.__("common.actions.select_staff"),
              filterable: "",
              menuClass: "activities-listing-mass-assign-owner-select-menu"
            },
            model: {
              value: _vm.selectedOwner,
              callback: function($$v) {
                _vm.selectedOwner = $$v
              },
              expression: "selectedOwner"
            }
          },
          _vm._l(_vm.metas.authors, function(staff) {
            return _c("CompassDropdownSelectOption", {
              key: staff.id,
              attrs: {
                label: staff.firstname + " " + staff.lastname,
                value: staff.id,
                type: "avatar",
                avatar: _vm.getAvatarObject(
                  staff.firstname,
                  staff.lastname,
                  staff.avatar
                )
              }
            })
          }),
          1
        )
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }